import React from "react";
import { observer } from "mobx-react-lite";
import MultiPlatformEwaybillResultStore from "../MultiPlatformEwaybillResultStore";
import RemarkPrintFailOrderButton from "./RemarkPrintFailOrderButton";
import { BatchUpdateSellerRemarksDialogProps } from "@/scenes/OrderManagement/components/dialogs/BatchUpdateSellerRemarksDialog";

interface PrintFailOperationProps
    extends Pick<BatchUpdateSellerRemarksDialogProps, "onUpdateOrderSellerRemarks" | "onUpdateSupplierOrderRemarks"> {
    store: MultiPlatformEwaybillResultStore;
}

const PrintFailOperation: React.FC<PrintFailOperationProps> = function (props) {
    const { store, onUpdateOrderSellerRemarks, onUpdateSupplierOrderRemarks } = props;

    const hasDataSourceErrors = store.dataSource.some((item) => !!item.errorMsg);
    const hasMappingErrors = store.waybillNoPrintErrorsMapping.size > 0;
    const hasErrors = hasDataSourceErrors || hasMappingErrors;

    if (!hasErrors) {
        return null;
    }

    return (
        <RemarkPrintFailOrderButton
            store={store}
            onUpdateOrderSellerRemarks={onUpdateOrderSellerRemarks}
            onUpdateSupplierOrderRemarks={onUpdateSupplierOrderRemarks}
        />
    );
};

export default observer(PrintFailOperation);
